import ndjsonStream, { NDJsonError } from 'can-ndjson-stream';

import fetch from './fetch';

export async function getNdJsonStream<T>(url: string, fetchOptions: RequestInit = {}) {
  const options = {
    ...fetchOptions,
    headers: {
      ...(fetchOptions.headers || {}),
      Accept: 'application/x-ndjson',
    },
  };

  const response = await fetch(url, options);
  if (response.headers.get('Content-Type') !== 'application/x-ndjson') {
    throw new Error(`Unexpected content type: ${response.headers.get('Content-Type')}`);
  }

  return ndjsonStream<T>(response.body);
}

export function ndJsonChunkIsError(chunk: any): chunk is NDJsonError {
  return !!(chunk as NDJsonError).error;
}
